import { routes, type useMakeUrl } from "./urls";

function safeDecodeURIComponent(s: string): string {
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
}

export function resolveWorkflowFileHref(
  href: string,
  stepNames: readonly string[],
  makeUrl: ReturnType<typeof useMakeUrl>,
  fromStep?: string
): string | null {
  if (/^[a-z][a-z0-9+.-]*:/i.test(href) || href.startsWith("#")) return null;
  if (href.startsWith("<") && href.endsWith(">")) href = href.slice(1, -1);
  const segs: string[] = fromStep ? [fromStep] : [];
  for (const rawPart of href.split("/")) {
    const part = safeDecodeURIComponent(rawPart);
    if (part === "" || part === ".") continue;
    if (part === "..") segs.pop();
    else segs.push(part);
  }
  if (segs.length === 0) return null;
  const [targetStep, ...fileParts] = segs;
  if (!targetStep || !stepNames.includes(targetStep)) return null;
  const params: Record<string, string> = { step: targetStep };
  if (fileParts.length > 0) {
    params.file = fileParts.join("/");
    params.stepTab = "code";
    params.showRuns = "";
  }
  return makeUrl(routes.space.workflow, params);
}
